import { ErrorHandler, Injectable, inject } from '@angular/core';

import { ObservabilityService } from './observability.service';

@Injectable()
export class ReportingErrorHandler implements ErrorHandler {
  private readonly observability = inject(ObservabilityService);

  handleError(error: unknown): void {
    this.observability.error('runtime', error);
    console.error(error);
  }
}
